module.exports = __webpack_public_path__ + "static/img/建筑智能化_建筑智能化2@2x.4b98591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_建筑智能化2@2x.png
// module id = NBHj
// module chunks = 1